import HealthCare from "./HealthCare.container";

export default HealthCare;
